var chunkMapping = {
	"68": [
		9004
	],
	"90": [
		87090
	],
	"280": [
		92280
	],
	"344": [
		88344
	],
	"754": [
		62754
	],
	"971": [
		52971
	],
	"984": [
		91984
	],
	"996": [
		50996
	]
};
var idToExternalAndNameMapping = {
	"9004": [
		"default",
		"./SetLang",
		39974
	],
	"50996": [
		"default",
		"./Article",
		37469
	],
	"52971": [
		"default",
		"./IsAuthenticated",
		39974
	],
	"62754": [
		"default",
		"./Login",
		39974
	],
	"87090": [
		"default",
		"./Logout",
		39974
	],
	"88344": [
		"default",
		"./Receipts",
		37469
	],
	"91984": [
		"default",
		"./SetTheme",
		39974
	],
	"92280": [
		"default",
		"./Start",
		39974
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_modules__[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_modules__[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}